// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1npkz","content":"styles_content__Wo1Xd","checkbox":"styles_checkbox__184NE","checkboxLabel":"styles_checkboxLabel__1OIl9"};